var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowlineright(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.66 122.34a8 8 0 010 11.32l-72 72a8 8 0 01-11.32-11.32L164.69 136H32a8 8 0 010-16h132.69l-58.35-58.34a8 8 0 0111.32-11.32zM216 32a8 8 0 00-8 8v176a8 8 0 0016 0V40a8 8 0 00-8-8z"
  })));
}

export default SvgArrowlineright;